import { Tag } from 'antd'

export function statusTag(status: string): JSX.Element {
  const s = status?.toLowerCase()
  if (s === 'success') {
    return <Tag color='green'>success</Tag>
  }
  if (s === 'pending') {
    return <Tag color='orange'>pending</Tag>
  }
  return <Tag>{status}</Tag>
}
